// Package imports:
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
// Style imports:
// import './SpinnerIcon.scss';

const SpinnerIcon: React.FC = () => (
    <FontAwesomeIcon icon={faSpinnerThird} className='SpinnerIcon' />
);

export default SpinnerIcon;